import type { RouteLocationNormalized, RouteLocationRaw, Router } from 'vue-router';
import { getMobileClient } from '@/services/mobile-client';

export const ACCOUNT_SETTINGS_GROUPS = [
  { title: '个人偏好', pages: [
    { name: 'account-profile-settings', title: '个人资料', icon: 'ri-user-settings-line', description: '头像、账号信息与使用偏好' },
    { name: 'account-appearance-settings', title: '外观主题', icon: 'ri-palette-line', description: '明暗模式、背景与我的主题' },
    { name: 'account-notification-settings', title: '通知设置', icon: 'ri-notification-3-line', description: '本设备提醒、推送与系统通知权限' },
  ] },
  { title: '安全与隐私', pages: [
    { name: 'account-security-settings', title: '登录安全', icon: 'ri-shield-keyhole-line', description: '登录方式、密码与会话管理' },
    { name: 'account-privacy-settings', title: '隐私与数据', icon: 'ri-shield-user-line', description: '法律文档、同意记录与数据权利' },
  ] },
  { title: '模型与连接', pages: [
    { name: 'account-model-settings', title: '大脑设置', icon: 'ri-brain-line', description: '系统模型与自定义模型' },
    { name: 'account-connectors', title: '连接器', icon: 'ri-links-line', description: '管理邮箱和企业沟通渠道' },
  ] },
  { title: '账户权益', pages: [
    { name: 'account-orders', title: '套餐、用量与订单', icon: 'ri-bank-card-line', description: '套餐资源、AI 积分与购买记录' },
    { name: 'account-rewards', title: '奖励中心', icon: 'ri-gift-line', description: '签到、邀请与广告奖励' },
    { name: 'account-coupons', title: '卡券中心', icon: 'ri-coupon-3-line', description: '兑换码、优惠券与权益兑换' },
  ] },
] as const;

export const ACCOUNT_SETTINGS_PAGES = ACCOUNT_SETTINGS_GROUPS.flatMap((group) => [...group.pages]);

export function accountSettingsPageAvailable(name: string): boolean {
  return name !== 'account-notification-settings' || Boolean(getMobileClient()?.notifications);
}

export function isAccountSettingsRoute(path: string): boolean {
  return path === '/settings' || path.startsWith('/settings/');
}

// 返回地址只允许已注册的站内业务页，避免直接访问、登录跳转或设置页之间形成循环。
export function accountReturnPath(router: Router, value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\r\n]/.test(value)) return;
  const target = router.resolve(value);
  if (!target.meta.requiresAuth || target.matched.at(-1)?.redirect || isAccountSettingsRoute(target.path) || target.path === '/notifications') return;
  if (target.name === 'workspace-management' && ['regional', 'appearance'].includes(String(target.query.section))) return;
  return target.fullPath;
}

export function accountSettingsBackLocation(router: Router, route: Pick<RouteLocationNormalized, 'path' | 'query'> & { name?: string | symbol | null }): RouteLocationRaw {
  const returnTo = accountReturnPath(router, route.query.returnTo);
  const query = returnTo ? { returnTo } : {};
  if (route.name === 'theme-studio') return { name: 'account-appearance-settings', query };
  if (isAccountSettingsRoute(route.path) && route.name !== 'account-settings') return { name: 'account-settings', query };
  return returnTo || { name: 'workspace-entry' };
}
